import { BadgeProps } from "primereact/badge"
import { SelectItemOptionsType } from "primereact/selectitem"
import { Plan } from "../../types/subscription"

export const UNLIMITED = "Unlimited"
export const PAY_AS_YOU_GO = "PayAsYouGo"

export const planTypes: SelectItemOptionsType = [
  {
    label: PAY_AS_YOU_GO,
    value: Plan.PAY_AS_YOU_GO
  },
  {
    label: UNLIMITED,
    value: Plan.UNLIMITED
  }
]

export const priceIdDev = {
  [Plan.UNLIMITED]: "price_1RZWBWQ365BFf8Ym5Dw700gD",
  [Plan.PAY_AS_YOU_GO]: "price_1RZWCYQ365BFf8Ym5kVSa7E3"
}

export const priceIdStaging = {
  [Plan.UNLIMITED]: "price_1RrkmxCHWsXFpI2osIQo4dXE",
  [Plan.PAY_AS_YOU_GO]: "price_1RrkpKCHWsXFpI2otHzIiaGD"
}

export const getPriceIds = (stage: string) => {
  switch (stage) {
    case "dev":
      return priceIdDev
    case "staging":
      return priceIdStaging
    default:
      return priceIdDev // Default to dev
  }
}

export enum SubscriptionStatus {
  ACTIVE = "active",
  TRIALING = "trialing",
  CANCELED = "canceled",
  UNPAID = "unpaid"
}

export const statusBadgeText: { [key in SubscriptionStatus]: string } = {
  active: "Active",
  trialing: "Trialing",
  canceled: "Canceled",
  unpaid: "Unpaid"
}

export const statusBadgeStyle: { [key in SubscriptionStatus]: BadgeProps["severity"] } = {
  active: "success",
  trialing: "info",
  canceled: "danger",
  unpaid: "danger"
}
